import moment from 'moment'

export function formatPrice(price) {
  let formatValue = price * 1
  if (isNaN(formatValue)) {
    formatValue = 0
  }
  formatValue = formatValue.toFixed(2)
  return `￥${formatValue}`
}

export function fileReader(file) {
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort();
      reject(new Error('Problem parsing file'));
    };

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.readAsText(file);
  });
}

/**
 * 格式化Date对象到日期字符串
 * @param {Date} date
 * @param {boolean} endOfDay 是否到当天结束时间
 */
export function dateToString(date, endOfDay = false) {
  const time = moment(date)
  if (endOfDay) {
    time.endOf('day')
  }
  return time.format('YYYY-MM-DD HH:mm:ss')
}

/**
 * 格式化Date对象到日期字符串
 * @param {string} dateStr
 */
export function stringToDate(dateStr) {
  return moment(dateStr).toDate()
}
